import { ProcessType } from './enums/process-type';

export class SettingsBase {
    type: ProcessType;
}
